(() => {
  const scope = document.querySelector('.ak-guided-page');
  if (!scope || scope.dataset.akReviewsInitialized === 'true') return;
  scope.dataset.akReviewsInitialized = 'true';

  const selector = '.jdgm-review-widget[data-product-id]';
  const controllers = new Map();
  const strings = {
    previous: scope.dataset.akReviewsPrev || 'Previous reviews',
    next: scope.dataset.akReviewsNext || 'Next reviews',
    label: scope.dataset.akReviewsLabel || 'Customer reviews on this page',
    status: scope.dataset.akReviewsStatus || '{first}–{last} of {count} reviews on this page',
    details: scope.dataset.akReviewsDetails || 'Rating details',
    readMore: scope.dataset.akReviewsReadMore || 'Read more',
    readLess: scope.dataset.akReviewsReadLess || 'Read less'
  };
  let sequence = 0;

  function enhance(widget) {
    if (controllers.has(widget)) return;
    let track = null;
    let controls = null;
    let previous = null;
    let next = null;
    let status = null;
    let frame = 0;
    let disposed = false;
    let cards = [];
    let originalAttributes = null;
    let resizeObserver = null;
    let headerState = null;
    const previews = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function ensureId(element, prefix) {
      if (!element.id) {
        let id;
        do { id = `${prefix}-${++sequence}`; } while (document.getElementById(id));
        element.id = id;
      }
      return element.id;
    }

    function restoreId(element, originalId) {
      if (originalId === null) element.removeAttribute('id');
      else element.id = originalId;
    }

    function cleanupHeader() {
      if (!headerState) return;
      headerState.panels.forEach(panel => {
        if (panel.hidden === null) panel.element.removeAttribute('hidden');
        else panel.element.setAttribute('hidden', panel.hidden);
        restoreId(panel.element, panel.id);
        panel.element.classList.remove('ak-review-details-panel');
      });
      headerState.toggle?.remove();
      headerState.header.classList.remove('ak-review-compact-header');
      headerState = null;
    }

    function enhanceHeader() {
      const header = widget.querySelector('.jdgm-rev-widg__header');
      const panels = header ? [header.querySelector('.jdgm-histogram')].filter(Boolean) : [];
      if (headerState && headerState.header === header && (!headerState.toggle || headerState.toggle.isConnected) &&
        panels.length === headerState.panels.length && panels.every((panel, index) => panel === headerState.panels[index].element)) return;
      cleanupHeader();
      if (!header) return;
      const state = {
        header,
        panels: panels.map(element => ({ element, id: element.getAttribute('id'), hidden: element.getAttribute('hidden') })),
        toggle: panels.length ? document.createElement('button') : null
      };
      header.classList.add('ak-review-compact-header');
      widget.classList.add('ak-guided-reviews');
      headerState = state;
      if (!state.toggle) return;
      const initiallyOpen = window.matchMedia('(min-width: 990px)').matches;
      state.toggle.type = 'button';
      state.toggle.className = 'ak-review-details-toggle';
      state.toggle.dataset.akReviewsUi = 'true';
      state.toggle.textContent = strings.details;
      state.toggle.setAttribute('aria-expanded', String(initiallyOpen));
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = initiallyOpen ? '−' : '+';
      state.toggle.append(icon);
      state.toggle.setAttribute('aria-controls', state.panels.map(panel => {
        panel.element.classList.add('ak-review-details-panel');
        panel.element.hidden = !initiallyOpen || panel.hidden !== null;
        return ensureId(panel.element, 'ak-review-details');
      }).join(' '));
      state.toggle.addEventListener('click', () => {
        const open = state.toggle.getAttribute('aria-expanded') !== 'true';
        state.toggle.setAttribute('aria-expanded', String(open));
        icon.textContent = open ? '−' : '+';
        state.panels.forEach(panel => { panel.element.hidden = !open || panel.hidden !== null; });
      });
      header.append(state.toggle);
    }

    function removePreview(body, state) {
      body.classList.remove('ak-review-preview');
      state.button.remove();
      restoreId(body, state.id);
      previews.delete(body);
    }

    function refreshPreviews() {
      previews.forEach((state, body) => {
        if (!track || !track.contains(body)) removePreview(body, state);
      });
      if (!track) return;
      track.querySelectorAll('.jdgm-rev > .jdgm-rev__content > .jdgm-rev__body').forEach(body => {
        if (!body.getClientRects().length) return;
        const style = getComputedStyle(body);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.65;
        const long = body.scrollHeight > lineHeight * 4 + 3;
        let state = previews.get(body);
        if (!state && !long) return;
        if (!state) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ak-review-readmore';
          button.dataset.akReviewsUi = 'true';
          state = { button, expanded: false, id: body.getAttribute('id') };
          button.setAttribute('aria-controls', ensureId(body, 'ak-review-body'));
          button.setAttribute('aria-expanded', 'false');
          button.textContent = strings.readMore;
          button.addEventListener('click', () => {
            state.expanded = !state.expanded;
            body.classList.toggle('ak-review-preview', !state.expanded);
            button.setAttribute('aria-expanded', String(state.expanded));
            button.textContent = state.expanded ? strings.readLess : strings.readMore;
            schedule();
          });
          body.after(button);
          previews.set(body, state);
        }
        body.classList.toggle('ak-review-preview', long && !state.expanded);
        if (state.button.hidden !== !long) state.button.hidden = !long;
      });
    }

    function getCards() {
      if (!track) return [];
      return Array.from(track.children).filter(card =>
        card.matches('.jdgm-rev') && card.getClientRects().length && getComputedStyle(card).display !== 'none'
      );
    }

    function update() {
      frame = 0;
      if (disposed || !track || !track.isConnected) return;
      observer.disconnect();
      refreshPreviews();
      observer.observe(widget, { childList: true, subtree: true });
      const items = getCards();
      if (controls.hidden !== (items.length === 0)) controls.hidden = items.length === 0;
      if (!items.length) return;
      const bounds = track.getBoundingClientRect();
      const rtl = getComputedStyle(track).direction === 'rtl';
      const visible = items.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
        .filter(item => item.rect.right > bounds.left + 4 && item.rect.left < bounds.right - 4);
      const firstRect = items[0].getBoundingClientRect();
      const lastRect = items[items.length - 1].getBoundingClientRect();
      const atStart = rtl ? firstRect.right <= bounds.right + 3 : firstRect.left >= bounds.left - 3;
      const atEnd = rtl ? lastRect.left >= bounds.left - 3 : lastRect.right <= bounds.right + 3;
      if (previous.disabled !== atStart) previous.disabled = atStart;
      if (next.disabled !== atEnd) next.disabled = atEnd;
      const firstIndex = visible.length ? visible[0].index : 0;
      const lastIndex = visible.length ? visible[visible.length - 1].index : firstIndex;
      const message = strings.status
        .replace('{first}', String(firstIndex + 1))
        .replace('{last}', String(lastIndex + 1))
        .replace('{count}', String(items.length));
      if (status.textContent !== message) status.textContent = message;
    }

    function schedule() {
      if (!disposed && !frame) frame = requestAnimationFrame(update);
    }

    function move(direction) {
      const items = getCards();
      if (!items.length) return;
      const rect = items[0].getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollBy({
        left: direction * (rtl ? -1 : 1) * (rect.width + gap),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    function keydown(event) {
      if (event.target !== track) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        track.scrollTo({
          left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * track.scrollWidth,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      }
    }

    function unbind() {
      if (resizeObserver) resizeObserver.disconnect();
      previews.forEach((state, body) => removePreview(body, state));
      if (track) {
        track.removeEventListener('scroll', schedule);
        track.removeEventListener('keydown', keydown);
        track.classList.remove('ak-review-track');
        Object.entries(originalAttributes || {}).forEach(([name, value]) => {
          if (value === null) track.removeAttribute(name);
          else track.setAttribute(name, value);
        });
      }
      if (controls) controls.remove();
      track = null;
      controls = null;
      cards = [];
    }

    function bind(list) {
      track = list;
      originalAttributes = Object.fromEntries(['id', 'tabindex', 'role', 'aria-label', 'aria-roledescription']
        .map(name => [name, track.getAttribute(name)]));
      if (!track.id) {
        let id;
        do { id = `ak-review-track-${++sequence}`; } while (document.getElementById(id));
        track.id = id;
      }
      if (!track.hasAttribute('tabindex')) track.tabIndex = 0;
      if (!track.hasAttribute('role')) track.setAttribute('role', 'region');
      if (!track.hasAttribute('aria-label')) track.setAttribute('aria-label', strings.label);
      track.classList.add('ak-review-track');
      widget.classList.add('ak-guided-reviews');
      controls = document.createElement('div');
      controls.className = 'ak-review-controls';
      controls.dataset.akReviewsUi = 'true';
      status = document.createElement('span');
      status.className = 'ak-review-position';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      controls.append(status);
      const makeButton = (label, symbol, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ak-review-button';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', track.id);
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = symbol;
        button.append(icon);
        button.addEventListener('click', () => move(direction));
        controls.append(button);
        return button;
      };
      const rtl = getComputedStyle(track).direction === 'rtl';
      previous = makeButton(strings.previous, rtl ? '→' : '←', -1);
      next = makeButton(strings.next, rtl ? '←' : '→', 1);
      track.before(controls);
      track.addEventListener('scroll', schedule, { passive: true });
      track.addEventListener('keydown', keydown);
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(schedule);
        resizeObserver.observe(track);
      }
    }

    function reconcile() {
      if (disposed) return;
      const list = widget.querySelector('.jdgm-rev-widg__reviews');
      observer.disconnect();
      enhanceHeader();
      if (list !== track || (track && !controls.isConnected)) {
        unbind();
        if (list) bind(list);
      }
      if (track) {
        const currentCards = Array.from(track.children).filter(card => card.matches('.jdgm-rev'));
        if (currentCards.length !== cards.length || currentCards.some((card, index) => card !== cards[index])) {
          track.scrollLeft = 0;
          cards = currentCards;
        }
        refreshPreviews();
      }
      observer.observe(widget, { childList: true, subtree: true });
      schedule();
    }

    const observer = new MutationObserver(records => {
      if (records.some(record => !(record.target instanceof Element && record.target.closest('[data-ak-reviews-ui]')))) reconcile();
    });
    window.addEventListener('resize', schedule, { passive: true });
    controllers.set(widget, () => {
      disposed = true;
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      unbind();
      cleanupHeader();
      widget.classList.remove('ak-guided-reviews');
      controllers.delete(widget);
    });
    reconcile();
  }

  function init() {
    controllers.forEach((dispose, widget) => {
      if (!widget.isConnected || !scope.contains(widget)) dispose();
    });
    scope.querySelectorAll(selector).forEach(enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, widget) => {
      if (event.target.contains(widget)) dispose();
    });
  });
})();
